import { links as Links } from "src/app/types/orders/order";

const CellLinks = ({ links }: { links?: Array<Links> | null }) => {
    return (
        <ul className="padding-start-0 mb-0">
            {links?.map((link: Links, index: number) => (
                <li key={index} style={{ listStyleType: "none" }}>
                    {link.url} ({link.anchor})
                </li>
            ))}
        </ul>
    );
};

export default CellLinks;
